"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MarketplaceModule = /** @class */ (function () {
    function MarketplaceModule() {
    }
    return MarketplaceModule;
}());
exports.MarketplaceModule = MarketplaceModule;
